import {
  PREPARE_TOUR_TYPE_REGIONAL,
  PREPARE_TOUR_TYPE_FIX,
  PARTNER,
  BASKET_TYPE_REGIONAL_TOUR,
  BASKET_TYPE_FIX_TOUR,
  FREE,
  REQUEST
} from "../../../util/enumTypes";
import util from "../../../util/util";

import * as STYLE from "../../custom/rowCard/styleRowCard";
import ColumnRowCard from "../../custom/rowCard/columnRowCard";
import rowCard from "../../custom/rowCard/rowCard.vue";
import panelInfo from "../../custom/panelInfo/panelInfo.vue";

import { mapState } from "vuex";

const moment = require("moment");

export default {
  components: {
    rowCard,
    panelInfo
  },
  props: {
    tourType: String,
    tarifPeriods: {
      type: Array,
      default: []
    },
    guideLanguage: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      datePikerOptions: {
        disabledDate: null
      },
      dateOutPikerOptions: {
        disabledDate: this.checkFixDateDisabled
      },
      checkIn: null,
      checkOut: null,
      language: null,
      count: null,
      countOptions: [],
      tarifId: null,
      tarifNameOptions: [],
      nonWeekDays: [],
      rangePeriods: []
    };
  },
  computed: {
    ...mapState({
      lang: state => state.SettingStorage.language.toLowerCase(),
      filter: state => state.BannerStorage.filter,
      filterParams: state => state.BannerStorage.filterParams,
      mobile: state => state.SettingStorage.mobile
    }),
    checkInRange: {
      get() {
        return [this.checkIn, this.checkOut];
      },
      set(value) {
        this.checkIn = value[0];
        this.checkOut = value[1];
      }
    },
    controlSize() {
      return this.mobile ? "medium" : "mini";
    },
    isFIXTour() {
      return this.tourType == PREPARE_TOUR_TYPE_FIX;
    },
    isRegionalTour() {
      return this.tourType == PREPARE_TOUR_TYPE_REGIONAL;
    },
    isPartner() {
      return this.$store.getters.Role === PARTNER;
    },
    languageOptions() {
      return this.guideLanguage.map(gl => {
        return {
          label: gl.name,
          value: gl.id
        };
      });
    },

    tarifItems() {
      let result = [];
      let i, j;
      let s;
      let cInFormat, cOutFormat;

      // Todo: перенести логику на бэк
      if (this.tarifPeriods.length) {
        if (this.isRegionalTour) {
          if (this.checkIn && this.count) {
            // Получаем список региональных тарифов проходящие по фильтру
            let checkIn = moment(this.checkIn).startOf('day').valueOf();
            let items = this.tarifPeriods.filter(tp => {
              let from = moment(tp.from).valueOf();
              let to = moment(tp.to).valueOf();
              return (
                tp.show &&
                checkIn >= from &&
                checkIn <= to &&
                this.count >= tp.countPaxFrom &&
                this.count <= tp.countPaxTo
              );
            });

            // Если несколько тарифов с одинаковым имененем, то выбираем тот, у которого цена выше
            i = items.length - 1;
            while (i > 0) {
              s = items[i].name.toLowerCase();
              j = i - 1;
              while (j >= 0) {
                if (s == items[j].name.toLowerCase()) {
                  if (items[i].price <= items[j].price) {
                    items.splice(i, 1);
                  } else {
                    items.splice(j, 1);
                  }
                  break;
                }
                j--;
              }
              i--;
            }

            // А вот и алмаз
            if (items.length) {
              cInFormat = moment(this.checkIn).format("YYYY-MM-DD");
              cOutFormat = moment(this.checkIn)
                .add(items[0].duration, "day")
                .format("YYYY-MM-DD");
            }

            items.forEach(t => {
              result.push({
                id: t.id,
                checkIn: cInFormat,
                checkOut: cOutFormat,
                duration: t.duration,
                durationText: this.getNights(t.duration, this.lang),
                count: this.count,
                name: t.name,
                totalPrice: this.count * t.price,
                status: this.resetStatus(t.status, this.count, t.freePlaces)
              });
            });
          }
        } else if (this.isFIXTour) {
          if (this.checkIn && this.checkOut && this.count) {
            // Получаем список региональных тарифов проходящие по фильтру
            let checkIn = moment(this.checkIn).valueOf();
            let checkOut = moment(this.checkOut).valueOf();

            let tarifName = this.tarifId
              ? this.tarifNameOptions
                .find(tn => tn.value == this.tarifId)
                .label.toLowerCase()
              : null;

            let items = this.tarifPeriods.filter(tp => {
              let from = moment(tp.from).valueOf();
              let to = moment(tp.to).valueOf();
              let isTarif = this.tarifId
                ? tarifName == tp.name.toLowerCase()
                : true;

              // Todo: Убрать проверку. Фронт доолжен отобразить все туры, котоыре пришли с бэка.
              return (
                tp.show &&
                checkIn < to &&
                checkOut > from &&
                this.count >= tp.countPaxFrom &&
                this.count <= tp.countPaxTo &&
                isTarif
              );
            });

            // Если несколько тарифов с одинаковым имененем и датами, то выбираем тот, у которого цена выше
            i = items.length - 1;
            while (i > 0) {
              s = items[i].name.toLowerCase();
              j = i - 1;
              while (j >= 0) {
                if (
                  items[i].from == items[j].from &&
                  items[i].to == items[j].to &&
                  s == items[j].name.toLowerCase()
                ) {
                  if (items[i].price <= items[j].price) {
                    items.splice(i, 1);
                  } else {
                    items.splice(j, 1);
                  }
                  break;
                }
                j--;
              }
              i--;
            }

            // А вот и еще алмаз
            items.forEach(t => {
              const displayedCheckIn = getDisplayedTourCheckIn(moment(t.from), moment(t.to), t.duration, moment(new Date(checkIn)));

              result.push({
                id: t.id,
                checkIn: displayedCheckIn.format("YYYY-MM-DD"),
                checkOut: displayedCheckIn.add(t.duration, 'days').format("YYYY-MM-DD"),
                duration: t.duration,
                durationText: this.getNights(t.duration, this.lang),
                count: this.count,
                name: t.name,
                totalPrice: this.count * t.price,
                status: this.resetStatus(t.status, this.count, t.freePlaces)
              });
            });
          }
        }
      }

      return result;
    },
    periodMinFrom() {
      // Минимальная дата заезда
      if (!this.tarifPeriods.length) {
        return null;
      }

      let min = this.tarifPeriods.reduce((min, current) => {
        return current.from < min ? current.from : min;
      }, this.tarifPeriods[0].from);

      return moment(min);
    },
    periodMaxFrom() {
      // Минимальная дата заезда
      if (!this.tarifPeriods.length) {
        return null;
      }

      let max = this.tarifPeriods.reduce((max, current) => {
        return current.from > max ? current.from : max;
      }, this.tarifPeriods[0].from);

      return moment(max);
    },
    languageName() {
      let result = "";
      if (this.language) {
        let d = this.guideLanguage.filter(gl => gl.id == this.language);
        if (d.length) {
          result = d[0].name;
        }
      }
      return result;
    },
    disabledSelect() {
      if (this.isRegionalTour) {
        return !this.checkIn || !this.language || !this.count;
      } else if (this.isFIXTour) {
        return !this.checkIn || !this.checkOut || !this.language || !this.count;
      }
    }
  },
  methods: {
    calc() {
      if (!this.tarifPeriods.length) {
        return false;
      }

      this.setNonWeekDays();
      this.setRangePeriods();

      if (this.filter.guideLanguageId) {
        this.language = this.filter.guideLanguageId;
      }
      if (
        this.languageOptions.length == 1 &&
        this.language != this.languageOptions[0].value
      ) {
        this.language = this.languageOptions[0].value;
      }

      this.change();
    },
    setNonWeekDays() {
      let i;
      this.nonWeekDays = [];
      if (this.tarifPeriods.length) {
        let days = this.tarifPeriods[0].nonWeekDays;
        if (days.length) {
          this.tarifPeriods.forEach(tp => {
            i = days.length - 1;
            while (i >= 0) {
              if (tp.nonWeekDays.indexOf(days[i]) == -1) {
                days.splice(i, 1);
              }
              i--;
            }
          });
          days.forEach(d => {
            this.nonWeekDays.push(d);
          });
        }
      }
    },
    setRangePeriods() {
      this.rangePeriods = [];
      this.tarifPeriods.forEach(tp => {
        this.rangePeriods.push({
          from: moment(tp.from).valueOf(),
          to: moment(tp.to).valueOf()
        });
      });
    },
    change() {
      if (this.isRegionalTour) {
        this.changeRegional();
      } else if (this.isFIXTour) {
        this.changeFix();
      }
    },
    changeRegional() {
      if (!this.checkIn) {
        this.checkIn =
          this.filter && this.filter.checkInFrom
            ? moment(this.filter.checkInFrom)
            : this.periodMinFrom;
      }
      this.setRegionalCountOption();
      return false;
    },
    changeFix() {
      if (!this.checkIn) {
        this.checkIn =
          this.filter && this.filter.checkInFrom
            ? moment(this.filter.checkInFrom)
            : this.periodMinFrom;
      }
      if (!this.checkOut) {
        this.checkOut =
          this.filter && this.filter.checkInTo
            ? moment(this.filter.checkInTo)
            : this.periodMaxFrom;
      }
      this.setFixOptions();
      return false;
    },
    changeCheckIn(val) {
      if (this.isRegionalTour) {
        this.$emit("changeCheckIn", moment(val).format("YYYY-MM-DD"));
      }
      if (this.isFIXTour && val) {
        let cIn = moment(val).valueOf();
        let cOut = moment(this.checkOut).valueOf();
        if (cIn > cOut) {
          this.checkOut = moment(cIn);
        }
      }
      this.change();
    },
    changeCheckOut(val) {
      if (this.isFIXTour && val) {
        let cIn = moment(this.checkIn).valueOf();
        let cOut = moment(val).valueOf();
        if (cIn > cOut) {
          this.checkIn = moment(cOut);
        }
      }
      this.change();
    },
    changeCheckRange(val) {
      if (this.checkIn != val[0]) {
        this.changeCheckIn(val[0]);
      }
      if (this.checkOut != val[1]) {
        this.changeCheckOut(val[1]);
      }
    },
    setRegionalCountOption() {
      this.countOptions = [];

      if (this.checkIn) {
        let checkIn = moment(this.checkIn).startOf('day').valueOf();
        let countList = this.tarifPeriods.filter(p => {
          let from = moment(p.from).valueOf();
          let to = moment(p.to).valueOf();
          return checkIn >= from && checkIn <= to;
        });
        let cnt = new Set();
        countList.forEach(cl => {
          for (let i = cl.countPaxFrom; i <= cl.countPaxTo; i++) {
            cnt.add(i);
          }
        });
        cnt.forEach(uc =>
          this.countOptions.push({
            label: uc,
            value: uc
          })
        );
        this.countOptions.sort((a, b) => (a.value <= b.value ? -1 : 1));

        if (!this.count && this.filterParams.countPax) {
          this.count = this.filterParams.countPax;
        }
        if (this.count && !cnt.has(this.count)) {
          this.count = null;
        }
        if (!this.count && this.countOptions.length) {
          this.count = this.countOptions[0].value;
        }
      }
    },
    setFixOptions() {
      this.countOptions = [];
      this.tarifNameOptions = [];

      if (this.checkIn) {
        let checkIn = moment(this.checkIn).startOf('day').valueOf();

        let tList = this.tarifPeriods.filter(p => {
          let from = moment(p.from).valueOf();
          let to = moment(p.to).valueOf();

          return checkIn >= from && checkIn <= to;
        });

        // Заполняем список по количеству возможных туристов
        let cnt = new Set();
        tList.forEach(cl => {
          for (let i = cl.countPaxFrom; i <= cl.countPaxTo; i++) {
            cnt.add(i);
          }
        });
        cnt.forEach(uc =>
          this.countOptions.push({
            label: uc,
            value: uc
          })
        );
        this.countOptions.sort((a, b) => (a.value <= b.value ? -1 : 1));

        if (!this.count && this.filterParams.countPax) {
          this.count = this.filterParams.countPax;
        }
        if (this.count && !cnt.has(this.count)) {
          this.count = null;
        }
        if (!this.count && this.countOptions.length) {
          this.count = this.countOptions[0].value;
        }

        // Заполняем список названий тарифов
        tList.forEach(cl => {
          if (
            this.tarifNameOptions.findIndex(
              n => n.label.toLowerCase() == cl.name.toLowerCase()
            ) == -1
          ) {
            this.tarifNameOptions.push({
              label: cl.name,
              value: cl.id
            });
          }
        });
        if (
          this.tarifNameOptions.findIndex(n => n.value == this.tarifId) == -1
        ) {
          this.tarifId = null;
        }
        if (!this.tarifId && this.tarifNameOptions.length == 1) {
          this.tarifId = this.tarifNameOptions[0].value;
        }
      }
    },
    getTarifItemsTitle() {
      let result = [];

      let column = new ColumnRowCard(
        "checkIn",
        this.$t("prepare_tour_booking_checkIn")
      );
      column.setColumnStyle(
        "10%",
        STYLE.STYLE_COLUMN_TITLE_CENTER_SELECT,
        STYLE.STYLE_COLUMN_DATA_CENTER_SELECT
      );
      result.push(column);

      column = new ColumnRowCard(
        "checkOut",
        this.$t("prepare_tour_booking_checkOut")
      );
      column.setColumnStyle(
        "10%",
        STYLE.STYLE_COLUMN_TITLE_CENTER_SELECT,
        STYLE.STYLE_COLUMN_DATA_CENTER_SELECT
      );
      result.push(column);

      column = new ColumnRowCard(
        "durationText",
        this.$t("prepare_tour_booking_duration")
      );
      column.setColumnStyle(
        "8%",
        STYLE.STYLE_COLUMN_TITLE_CENTER_SELECT,
        STYLE.STYLE_COLUMN_DATA_CENTER_SELECT
      );
      result.push(column);

      column = new ColumnRowCard(
        "language",
        this.$t("prepare_tour_booking_language")
      );
      column.setColumnStyle(
        "8%",
        STYLE.STYLE_COLUMN_TITLE_CENTER_SELECT,
        STYLE.STYLE_COLUMN_DATA_CENTER_SELECT
      );
      result.push(column);

      column = new ColumnRowCard(
        "count",
        this.$t("prepare_tour_booking_tourist_count")
      );
      column.setColumnStyle(
        "8%",
        STYLE.STYLE_COLUMN_TITLE_CENTER_SELECT,
        STYLE.STYLE_COLUMN_DATA_CENTER_SELECT
      );
      result.push(column);

      column = new ColumnRowCard(
        "name",
        this.$t("prepare_tour_booking_tarif_name")
      );
      column.setColumnStyle(
        "30%",
        STYLE.STYLE_COLUMN_TITLE_CENTER_SELECT,
        STYLE.STYLE_COLUMN_DATA_CENTER_SELECT
      );
      result.push(column);

      column = new ColumnRowCard(
        "status",
        this.$t("prepare_tour_booking_tarif_status")
      );
      column.setColumnStyle(
        "10%",
        STYLE.STYLE_COLUMN_TITLE_CENTER_SELECT,
        STYLE.STYLE_COLUMN_DATA_CENTER_SELECT
      );
      result.push(column);

      column = new ColumnRowCard(
        "totalPrice",
        this.$t("prepare_tour_booking_total")
      );
      column.setColumnStyle(
        "8%",
        STYLE.STYLE_COLUMN_TITLE_CENTER_SELECT,
        STYLE.STYLE_COLUMN_DATA_CENTER_MONEY
      );
      result.push(column);

      column = new ColumnRowCard("id", "");
      column.setColumnStyle(
        "8%",
        STYLE.STYLE_COLUMN_TITLE_CENTER_SELECT,
        STYLE.STYLE_COLUMN_DATA_CENTER_SELECT
      );
      result.push(column);

      return result;
    },
    getNights(nights, lang) {
      // Наименование ночей, с учетом языка и количества дней
      let n = util.powerPluarLang(nights, lang);
      if (n == 0) {
        return nights + " " + this.$t("search_form_pluar_nights_0");
      } else if (n == 1) {
        return nights + " " + this.$t("search_form_pluar_nights_1");
      } else {
        return nights + " " + this.$t("search_form_pluar_nights_2");
      }
    },
    getMoney(price) {
      return (
        util.formatMoney(price) + " " + this.$store.getters.SignCurrencyText
      );
    },
    checkRegionalDateDisabled(time) {
      let len = this.rangePeriods.length;
      let tm = time.getTime();
      let weekOfDate = time.getDay();
      weekOfDate = weekOfDate == 0 ? 7 : weekOfDate;

      if (this.nonWeekDays.indexOf(weekOfDate) > -1) {
        return false;
      }

      for (let i = 0; i < len; i++) {
        if (tm >= this.rangePeriods[i].from && tm <= this.rangePeriods[i].to) {
          return false;
        }
      }

      return true;
    },
    checkFixDateDisabled(time) {
      if (!this.periodMinFrom || !this.periodMaxFrom) {
        return true;
      }
      let tm = time.getTime();
      let min = this.periodMinFrom.valueOf();
      let max = this.periodMaxFrom.valueOf();
      return tm < min || tm > max;
    },
    getSaveObject(tarifId, type) {
      let result = {};
      let segment = {};
      let row = this.tarifItems.find(t => t.id == tarifId);

      segment.type = type;
      segment.objectBegin = {
        date: row.checkIn
      };
      segment.objectEnd = {
        date: row.checkOut
      };
      segment.services = [];
      segment.services.push({
        id: `${this.$route.params.id}`,
        idTarif: `${tarifId}`,
        language: this.language,
        tourists: []
      });

      result.id = 0;
      result.total = row.totalPrice;
      result.tourists = [];
      result.segments = [];
      result.segments.push(segment);
      result.commentary = "";

      return result;
    },
    getObjectForSave(tarifId) {
      if (this.isRegionalTour) {
        return this.getSaveObject(tarifId, BASKET_TYPE_REGIONAL_TOUR);
      } else if (this.isFIXTour) {
        return this.getSaveObject(tarifId, BASKET_TYPE_FIX_TOUR);
      }
    },
    clickSelected(tarifId) {
      this.$emit("bookingSaveObject", {
        data: this.getObjectForSave(tarifId),
        count: this.count,
        checkIn: this.isFIXTour
          ? moment(this.tarifItems.find(t => t.id == tarifId).checkIn).valueOf()
          : this.checkIn instanceof moment
            ? this.checkIn.valueOf()
            : this.checkIn.getTime()
      });
    },
    getStatusName(status) {
      if (status == FREE) {
        return this.$t("search_result_free");
      } else if (status == REQUEST) {
        return this.$t("search_result_request");
      } else {
        return "";
      }
    },
    isStatusFreeSale(status) {
      return status == FREE;
    },
    resetStatus(status, count, free) {
      if (status == FREE) {
        return count > free ? REQUEST : status;
      }
      return status;
    }
  },
  mounted() {
    this.calc();
    this.datePikerOptions.disabledDate = this.isRegionalTour
      ? this.checkRegionalDateDisabled
      : this.checkFixDateDisabled;
  },
  watch: {
    tarifPeriods: function() {
      this.calc();
    }
  }
};

function getDisplayedTourCheckIn(tourCheckIn, tourCheckOut, duration, formCheckIn) {
  if (tourCheckIn.isAfter(formCheckIn)) {
    return tourCheckIn;
  }

  let tmlFormCheckIn = moment(formCheckIn);

  if (tmlFormCheckIn.add(duration, 'days').isAfter(tourCheckOut)) {
    return tourCheckOut.subtract(duration, 'days');
  }

  return formCheckIn;
}
